import React, { useState, useEffect } from "react";
import useQueryParams from "../../../hooks/useQueryParams";
import { useUI } from "../../../context/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../../utilities/constants";
import PageTitle from "../../../components/common/PageTitle";
import FullPageLoader from "../../../components/ui/FullPageLoader";
import { formatDateTime } from "../../../utilities/helpers";
import RSModal from "../../../components/ui/RSModal";
import ButtonTertiary from "../../../components/ui/ButtonTertiary";
import ViewTemplatePopUp from "../CustomerNotif/TempleteDetails";
import Pagination from "../../../components/common/Pagination";
import ConfirmationModal from "../../../components/common/ConfirmationModal";
import UpdateNotification from "../CustomerNotif/UpdateNotification";
import AddTemplete from "../CustomerNotif/AddTemplete";
import ButtonTextIcon from "../../../components/ui/ButtonTextIcon";
import { FaPlus } from "react-icons/fa";
const buildQueryParams = (params) =>
  Object.entries(params)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
const AppNotificationTemplates = ({ sendallow = false }) => {
  const { updateQueryParam, queryParams } = useQueryParams();
  const tab = queryParams.get("tab") || "app";
  const section = queryParams.get("section") || "history";
  const pageNo = queryParams.get("pageNo") || 0;
  const pageSize = queryParams.get("pageSize") || 10;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const list = location.state;
  const { setSegmentTitle, addToastMessage } = useUI();
  useEffect(() => {
    setSegmentTitle("App Notification");
  }, [location.search]);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const query = buildQueryParams({
        pageNo: pageNo,
        pageSize: pageSize,
      });
      const response = await fetch(
        API_URL + `/api/1.0.0/template?sortOrder=DESC&${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-JWT-Assertion": localStorage.getItem("token"),
          },
        }
      );

      if (!response.ok) {
        setLoading(false);
        throw new Error("Failed to fetch templates");
      }

      const resp = await response.json();
      setData(resp.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [location]);

  const sendPushNotification = async (templateId) => {
    setLoading(true);
    try {
      const payload = {
        triggerForAll: list.allChecked,
        templateId: templateId,
      };

      const metaInfo = {};
      if (
        list.filterType === 1 ||
        list.filterType === 2 ||
        list.filterType === 3
      ) {
        metaInfo.searchType = list.filterType;
        metaInfo.search = list.search;
      }
      if (list.filterType === 4) {
        metaInfo.searchType = list.filterType;
        metaInfo.minBalance = list.minBalance;
        metaInfo.maxBalance = list.maxBalance;
      }
      if (list.filterType === 5) {
        metaInfo.searchType = list.filterType;
        metaInfo.startDate = list.startDate;
        metaInfo.endDate = list.endDate;
      }
      if (list.filterType === 6) {
        metaInfo.searchType = list.filterType;
        metaInfo.statusID = list.statusID;
      }
      if (list.filterType) {
        payload.metaInfo = metaInfo;
      }
      if (payload.triggerForAll) {
        payload.excludedUserIds = list.excludedTxnIds;
      } else {
        payload.includedUserIds = list.includedTxnIds;
      }
      const response = await fetch(API_URL + `/api/1.0.0/notification/notify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const resp = await response.json();

        if (resp?.result?.responseCode === 200) {
          addToastMessage({
            status: true,
            message: "Push notification sent successfully.",
          });
          navigate("/customers?pageNo=0&pageSize=10");
          setLoading(false);
          return;
        }
      }

      const resp = await response.json();
      addToastMessage({
        status: false,
        message:
          resp?.responseDescription ||
          "Something  went wrong. Please try again later.",
      });

      setLoading(false);
    } catch (error) {
      addToastMessage({
        status: false,
        message: "Something went wrong. Please try again later.",
      });
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const url = `${API_URL}/api/1.0.0/template/${id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        fetchTemplates();
        addToastMessage({
          status: true,
          message: "Template deleted successfully.",
        });
      } else {
        addToastMessage({
          status: false,
          message: "Failed to delete the template.",
        });
      }
    } catch (e) {
      console.error("Error deleting template", e);
      addToastMessage({
        status: false,
        message: "An error occurred while deleting the template.",
      });
    }
  };
  return (
    <>
      <PageTitle title="App Notification" />
      <FullPageLoader isActive={loading} />
      {!sendallow && <div
        className="flex center-right"
        style={{ gap: "50px", margin: "-50px 20px 5px 0px" }}
      >
        <RSModal
          selector={
            <ButtonTextIcon title="Add New" type="button" icon={<FaPlus />} />
          }
          content={<AddTemplete callback={fetchTemplates} />}
        />
      </div>}
      <div className="rs-table-holder">
        <table className="rs-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Subject</th>
              <th>Body</th>
              <th>
                <p className="flex center-center">Action</p>
              </th>
            </tr>
          </thead>
          {data && (
            <tbody>
              {data.data?.map((d, i) => (
                <tr key={i}>
                  <td>{data.pageNo * data.pageSize + i + 1}</td>
                  <td>
                    {" "}
                    <p
                      style={{
                        width: "190px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {d.name}
                    </p>
                  </td>
                  <td>
                    <p
                      style={{
                        width: "190px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {d.subject}
                    </p>
                  </td>
                  <td>
                    <p
                      style={{
                        width: "190px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {d.body}
                    </p>
                  </td>
                  <td>
                    <div className="flex center-center" style={{ gap: "12px" }}>
                      <div>
                        <RSModal
                          selector={
                            <ButtonTertiary title="View" actionType="view" />
                          }
                          content={<ViewTemplatePopUp id={d.id} />}
                        />
                      </div>
                      {!sendallow && <>
                      <div>
                        <RSModal
                          selector={
                            <ButtonTertiary title="Edit" actionType="edit" />
                          }
                          content={
                            <UpdateNotification
                              id={d.id}
                              callback={fetchTemplates}
                            />
                          }
                        />
                      </div>
                      <div>
                        <RSModal
                          selector={
                            <ButtonTertiary
                              title="Delete"
                              actionType="delete"
                            />
                          }
                          content={
                            <ConfirmationModal
                              message="Are you sure you want to delete this template?"
                              onConfirm={() => handleDelete(d.id)}
                            />
                          }
                        />
                      </div>
              </>}
                      {sendallow && (
                        <div>
                          <RSModal
                            selector={
                              <ButtonTertiary
                                title="Send"
                                actionType="reload"
                              />
                            }
                            content={
                              <ConfirmationModal
                                message={`Are you sure you want to send This Push Notification to Users?`}
                                onConfirm={() => sendPushNotification(d.id)}
                              />
                            }
                          />
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

              {(!data.data || data.data.length === 0) && !loading && (
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      textAlign: "center",
                      padding: "10px",
                    }}
                  >
                    <p> No records found. </p>
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {data &&
        (!sendallow ? (
          <Pagination
            totalRecords={data.totalRecords}
            pageNo={data.pageNo}
            pageSize={data.pageSize}
            baseUrl={`/marketing?tab=app&section=template&`}
          />
        ) : (
          <Pagination
            totalRecords={data.totalRecords}
            pageNo={data.pageNo}
            pageSize={data.pageSize}
            baseUrl={`/customers/notification?tab=app&`}
          />
        ))}
    </>
  );
};

export default AppNotificationTemplates;
